import React from 'react';
import { projectTypes, binImages } from '../data/mock';
import { Button } from './ui/button';
import { Home, Trash2, Building2, ArrowRight } from 'lucide-react';

const icons = [Home, Trash2, Building2];

const ForAnyProject = () => {
  return (
    <section className="py-24 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-blue-600 font-semibold tracking-wider uppercase text-sm">Versatile Solutions</span>
          <h2 className="text-4xl sm:text-5xl font-bold text-[#1a365d] mt-4 mb-6">
            The Right Bin for <span className="text-blue-500">Every Project</span>
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            From small cleanouts to major construction sites, we have the capacity and expertise to handle it all.
          </p>
        </div>

        {/* Project Types - Unique Card Layout */}
        <div className="grid lg:grid-cols-3 gap-8 mb-16">
          {projectTypes.map((project, index) => {
            const Icon = icons[index];
            return (
              <div
                key={index}
                className="group relative bg-white rounded-2xl border border-gray-200 p-8 hover:border-blue-300 transition-all duration-300 hover:shadow-xl"
              >
                {/* Icon */}
                <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-[#1a365d] rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <Icon className="h-8 w-8 text-white" />
                </div>

                <h3 className="text-xl font-bold text-[#1a365d] mb-4">
                  {project.title}
                </h3>
                <p className="text-gray-600 leading-relaxed mb-6">
                  {project.description}
                </p>

                <button 
                  onClick={() => {
                    const element = document.querySelector('#bins');
                    if (element) element.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="flex items-center text-blue-600 font-medium hover:text-[#1a365d] transition-colors group/btn"
                >
                  <span>View bin options</span>
                  <ArrowRight className="h-4 w-4 ml-2 group-hover/btn:translate-x-1 transition-transform" />
                </button>
              </div>
            );
          })}
        </div>

        {/* Stats Banner */}
        <div className="bg-[#1a365d] rounded-3xl p-8 md:p-12">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="text-5xl font-bold text-white mb-2">10+</div>
              <div className="text-blue-200">Years in Business</div>
            </div>
            <div className="text-center">
              <div className="text-5xl font-bold text-white mb-2">5,000+</div>
              <div className="text-blue-200">Projects Completed</div>
            </div>
            <div className="text-center">
              <div className="text-5xl font-bold text-white mb-2">4-40</div>
              <div className="text-blue-200">Yard Bin Range</div>
            </div>
            <div className="text-center">
              <div className="text-5xl font-bold text-white mb-2">95%</div>
              <div className="text-blue-200">Recycling Rate</div>
            </div>
          </div>
        </div>

        {/* Bottom Image Grid */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-4">
          {[binImages.residential, binImages.commercial, binImages.construction, binImages.industrial].map((img, idx) => (
            <div key={idx} className="rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-shadow">
              <img
                src={img}
                alt={`Bin ${idx + 1}`}
                className="w-full h-40 object-cover hover:scale-105 transition-transform duration-500"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ForAnyProject;
